import React from 'react';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT } from '../../utils/format';

export default function UnlockCard() {
  const { unlockInfo, tierConfig } = useContractState();
  if (!unlockInfo || !tierConfig) return null;

  const eff = unlockInfo.effectiveUnlocked;
  const pct = (eff / 15) * 100;

  return (
    <div className="unlock-card">
      <div className="row-between mb-8">
        <div>
          <div className="unlock-label">Levels Unlocked</div>
          <div className="unlock-value">{eff} <span className="of">/ 15</span></div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div className="unlock-label">Qualifying Directs</div>
          <div className="unlock-value">{unlockInfo.qualifyingDirects}</div>
        </div>
      </div>
      <div className="unlock-bar"><div className="fill" style={{ width: `${pct}%` }} /></div>
      <div className="unlock-hint">
        Each direct with {formatUSDT(tierConfig.directMinInvestment, { decimals: 0 })}+ unlocks{' '}
        <b>{tierConfig.levelsPerQualifyingDirect}</b> more levels
        {unlockInfo.adminOverride > 0 && <> · Admin floor: <b>{unlockInfo.adminOverride}</b></>}
      </div>
    </div>
  );
}
